const languages = [
  { id: 1, value: "af", name: "language.afrikaans" },
  { id: 2, value: "sq", name: "language.albanian" },
  { id: 3, value: "ar", name: "language.arabic" },
  { id: 4, value: "az", name: "language.azerbaijani" },
  { id: 5, value: "eu", name: "language.basque" },
  { id: 6, value: "bn", name: "language.bengali" },
  { id: 7, value: "be", name: "language.belarusian" },
  { id: 8, value: "bg", name: "language.bulgarian" },
  { id: 9, value: "ca", name: "language.catalan" },
  { id: 10, value: "zh", name: "language.chinese_simplified" },
  { id: 11, value: "zh-tw", name: "language.chinese_traditional" },
  { id: 12, value: "hr", name: "language.croatian" },
  { id: 13, value: "cs", name: "language.czech" },
  { id: 14, value: "da", name: "language.danish" },
  { id: 15, value: "nl", name: "language.dutch" },
  { id: 16, value: "en", name: "language.english" },
  { id: 17, value: "eo", name: "language.esperanto" },
  { id: 18, value: "et", name: "language.estonian" },
  { id: 19, value: "tl", name: "language.filipino" },
  { id: 20, value: "fi", name: "language.finnish" },
  { id: 21, value: "fr", name: "language.french" },
  { id: 22, value: "gl", name: "language.galician" },
  { id: 23, value: "ka", name: "language.georgian" },
  { id: 24, value: "de", name: "language.german" },
  { id: 25, value: "el", name: "language.greek" },
  { id: 26, value: "gu", name: "language.gujarati" },
  { id: 27, value: "ht", name: "language.haitian_creole" },
  { id: 28, value: "iw", name: "language.hebrew" },
  { id: 29, value: "hi", name: "language.hindi" },
  { id: 30, value: "hu", name: "language.hungarian" },
  { id: 31, value: "is", name: "language.icelandic" },
  { id: 32, value: "id", name: "language.indonesian" },
  { id: 33, value: "ga", name: "language.irish" },
  { id: 34, value: "it", name: "language.italian" },
  { id: 35, value: "ja", name: "language.japanese" },
  { id: 36, value: "kn", name: "language.kannada" },
  { id: 37, value: "ko", name: "language.korean" },
  { id: 38, value: "la", name: "language.latin" },
  { id: 39, value: "lv", name: "language.latvian" },
  { id: 40, value: "lt", name: "language.lithuanian" },
  { id: 41, value: "mk", name: "language.macedonian" },
  { id: 42, value: "ms", name: "language.malay" },
  { id: 43, value: "mt", name: "language.maltese" },
  { id: 44, value: "no", name: "language.norwegian" },
  { id: 45, value: "fa", name: "language.persian" },
  { id: 46, value: "pl", name: "language.polish" },
  { id: 47, value: "pt", name: "language.portuguese" },
  { id: 48, value: "ro", name: "language.romanian" },
  { id: 49, value: "ru", name: "language.russian" },
  { id: 50, value: "sr", name: "language.serbian" },
  { id: 51, value: "sk", name: "language.slovak" },
  { id: 52, value: "sl", name: "language.slovenian" },
  { id: 53, value: "es", name: "language.spanish" },
  { id: 54, value: "sw", name: "language.swahili" },
  { id: 55, value: "sv", name: "language.swedish" },
  { id: 56, value: "ta", name: "language.tamil" },
  { id: 57, value: "te", name: "language.telugu" },
  { id: 58, value: "th", name: "language.thai" },
  { id: 59, value: "tr", name: "language.turkish" },
  { id: 60, value: "uk", name: "language.ukrainian" },
  { id: 61, value: "ur", name: "language.urdu" },
  { id: 62, value: "vi", name: "language.vietnamese" },
  { id: 63, value: "cy", name: "language.welsh" },
  { id: 64, value: "yi", name: "language.yiddish" },
];

// const applicationLocales = [
//   { id: "en-us", name: "locales.english_us", active: true },
//   { id: "en-gb", name: "locales.english_gb", active: true },
//   { id: "fr-fr", name: "locales.french", active: false },
//   { id: "es-es", name: "locales.spanish", active: false },
//   { id: "de-de", name: "locales.german", active: false },
// ];

//   const langValueToName = languages.reduce(function(ret, obj){
//     ret[obj['value']] = obj['name'];
//     return ret;
//   }, {});

//   const detectLanguage = () => {
//     let language = null;

//     if (localStorage.getItem("language")) {
//       language = applicationLocales.filterBy('active', true).findBy('id', localStorage.getItem("language")) || applicationLocales.findBy('id', 'en-us');
//     } else {
//       let browserLanguage = window.navigator.userLanguage || window.navigator.language;
//       browserLanguage = browserLanguage?.toLowerCase();
//       language = applicationLocales.filterBy('active', true).findBy('id', browserLanguage) || applicationLocales.findBy('id', 'en-us');
//     }

//     return language;
//   };

export default languages;
//   export { langValueToName, applicationLocales, detectLanguage };
